var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.332a3.335 3.335 0 0 1-3.333-3.337 3.334 3.334 0 1 1 6.666 0A3.335 3.335 0 0 1 8 9.332M8 0C4.667 0 2 2.667 2 6c0 1.152.345 2.044.94 2.947l4.428 6.717A.755.755 0 0 0 8 16c.266 0 .5-.134.633-.336l4.427-6.717C13.655 8.044 14 7.152 14 6c0-3.333-2.667-6-6-6",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7c3ef52aeeabf672c47c4e531cb1bc74.svg";
export { ForwardRef as ReactComponent };